import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'

// providers
import {CatalogueProvider} from "./context/CatalogueContext"
import {BuddyProvider} from './context/BuddyContext'
import {SearchProvider} from './context/SearchContext'
import {FavouritesProvider} from './context/FavouritesContext'

// components
import {Activity, NotFound, Start, Select} from "./components/views/Buddy"

// the component
function App() {
  // render
  return (
    <Router>
      <CatalogueProvider>
        <BuddyProvider>
          <SearchProvider>
            <FavouritesProvider>
              <Switch>
                <Route path="/start/:id" component={Start} />
                <Route path="/activity/:slug" component={Activity} />
                <Route path="/select" component={Select} />
                <Route component={NotFound} />
              </Switch>
            </FavouritesProvider>
          </SearchProvider>
        </BuddyProvider>
      </CatalogueProvider>
    </Router>
  )
}

export default App